<template lang="pug">
    .settings(v-if='settings')
        div(v-if="settings.withTime")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}:
            | {{ settings.showTime + ' ' + $i18n.t('trainer.trainer_gameFormSettingValue_minutes')}}
        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfRows') }}:
            | {{ settings.amountOfRows }}
        div
            | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfElementsToRemember') }}:
            | {{ settings.amountOfItems }}
        div
            | {{ $i18n.t('support.support_createTicket_theme') }}:
            |  {{ settings.selectedTheme ? $i18n.tc('trainer.trainer_gameFormSetting_' + settings.selectedTheme.theme, 1) : '' }}
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            withIcon: Boolean,
        },
    };
</script>
